<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Booking Create",
      items: [
        {
          text: "Booking",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
        bookingId:"",
        is_ticket:false,
        booking_statuses:[],
        vendors:[],
        users:[],
        country_list:[],
      form: {
          search_reference_key:"",
        airline_pnr: "",
          api_pnr:"",
          base_fare:0,
          gross_fare:0,
          total_tax:0,
          invoice_fare:0,
          airline:"",
          trip_type:"",
          ait:0,
          currency:"",
          markup:0,
          commission:0,
          user_id:"",
          journey:[{
              flight_segments:
                  [{
                      operating_flight_number:'',
                      operating_airline_code:'',
                      origin_code:'',
                      origin_terminal:'',
                      destination_terminal:'',
                      destination_code:'',
                      destination_date:'',
                      arrival_date:'',
                      travel_duration:'',
                      booking_class:'',
                      baggage_information:''
                  }]
          }],
          passenger_info:[
              {
                  prefix:'',
                  first_name:'',
                  last_name:'',
                  date_of_birth:'',
                  passenger_type:'',
                  is_lead_pax:'',
                  gender:'',
                  nationality:'',
                  base_fare:0.0,
                  gross_fare:0.0,
                  total_tax:0.0,
                  ait:0.0,
                  markup:0.0,
                  commission:0.0,
                  currency:'',
                  invoice_fare:0.0,
                  passport_no:'',
                  passport_expiry:'',
                  passport_issue_country:'',
                  phone_code:'',
                  phone_number:'',
                  ticket_no:''
              }
          ],
          tickets:[]
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
        airline: {
            required,
        },
        airline_pnr: {
        required,
      },
        ait:{
            required,
        },
        api_pnr: {
            required,
        },
        api_vendor:{
            required,
        },
        base_fare: {
            required,
        },
        commission:{
            required,
        },
        currency:{
            required,
        },
        gross_fare: {
            required,
        },
        invoice_fare: {
            required,
        },
        total_tax: {
            required,
        },
        markup:{
            required,
        },
        search_reference_key:{
            required,
        },
        trip_type: {
            required,
        },
        user_id : {
            required,
        },
        journey: {
            required,
            $each:true
        },
        passenger_info: {
            required,
            $each: true
        }
    },
  },
  // created() {
  //   this.bookingId = this.$route.params.id;
  //     if(this.$route.params.is_ticketing!=undefined){
  //         this.is_ticket = this.$route.params.is_ticketing;
  //     }
  //
  // },
  mounted() {
    this.getVendorList();
    this.getAdminList();
    // this.getBookingStatuses();
      this.getCountryList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      addSegment(index){
          this.form.journey[index].flight_segments.push({operating_flight_number:''});
      },
      addJourney(){
          this.form.journey.push({flight_segments:[{operating_flight_number:''}]});
      },
      addPassenger(){
          this.form.passenger_info.push({prefix:'', first_name:'',
              last_name:'',
              date_of_birth:'',
              passenger_type:'',
              is_lead_pax:'',
              gender:'',
              nationality:'',
              base_fare:0.0,
              gross_fare:0.0,
              total_tax:0.0,
              ait:0.0,
              markup:0.0,
              commission:0.0,
              currency:'',
              invoice_fare:0.0,
              passport_no:'',
              passport_expiry:'',
              passport_issue_country:'',
              phone_code:'',
              phone_number:'',
              ticket_no:''});
      },
      deleteJourney(){
          if(this.form.journey.length>1){
              this.form.journey.splice(-1);
          }
      },
      deletePassenger(){
          this.form.passenger_info.splice(-1);
      },
      deleteSegment(index){
          if(index>=0 && this.form.journey[index].flight_segments.length>1 ){
              this.form.journey[index].flight_segments.splice(-1);
          }
      },
      calculateFromBaseFare(index){
          this.form.base_fare=this.form.passenger_info[index].base_fare;
          var gross=parseInt(this.form.passenger_info[index].base_fare)+parseInt(this.form.passenger_info[index].total_tax);
          this.form.passenger_info[index].gross_fare=parseInt(gross);
          var totalBaFare=0;
          this.form.passenger_info.map((passenger,i)=>{
              totalBaFare+=parseInt(passenger.base_fare);
          });
          this.form.base_fare=totalBaFare;
          this.calculateFareInformation();
      },
      calculateFromTotalTax(index){
          this.form.total_tax=this.form.passenger_info[index].total_tax;
          var gross=parseInt(this.form.passenger_info[index].base_fare)+parseInt(this.form.passenger_info[index].total_tax);
          this.form.passenger_info[index].gross_fare=parseInt(gross);
          var invoice=parseInt(this.form.passenger_info[index].gross_fare)+parseInt(this.form.passenger_info[index].ait)+parseInt(this.form.passenger_info[index].markup);
          this.form.passenger_info[index].invoice_fare=parseInt(invoice)-+parseInt(this.form.passenger_info[index].commission);
          var totalBaFare=0;
          this.form.passenger_info.map((passenger,i)=>{
              totalBaFare+=parseInt(passenger.total_tax);
          });
          this.form.total_tax=totalBaFare;
          this.calculateFareInformation();
      },
      calculateFromAit(index){
         this.form.ait=this.form.passenger_info[index].ait;
          var invoice=parseInt(this.form.passenger_info[index].gross_fare)+parseInt(this.form.passenger_info[index].ait)+parseInt(this.form.passenger_info[index].markup);
          this.form.passenger_info[index].invoice_fare=parseInt(invoice)-parseInt(this.form.passenger_info[index].commission);
          var totalBaFare=0;
          this.form.passenger_info.map((passenger,i)=>{
              totalBaFare+=parseInt(passenger.ait);
          });
          this.form.ait=totalBaFare;
          this.calculateFareInformation();
      },
      calculateFromMarkup(index){
          this.form.markup=this.form.passenger_info[index].markup;
          var invoice=parseInt(this.form.passenger_info[index].gross_fare)+parseInt(this.form.passenger_info[index].ait)+parseInt(this.form.passenger_info[index].markup);
          this.form.passenger_info[index].invoice_fare=parseInt(invoice)-parseInt(this.form.passenger_info[index].commission);
          var totalBaFare=0;
          this.form.passenger_info.map((passenger,i)=>{
              totalBaFare+=parseInt(passenger.markup);
          });
          this.form.markup=totalBaFare;
          this.calculateFareInformation();
      },
      calculateFromCommission(index){
          this.form.commission=this.form.passenger_info[index].commission;
          var invoice=parseInt(this.form.passenger_info[index].gross_fare)+parseInt(this.form.passenger_info[index].ait)+parseInt(this.form.passenger_info[index].markup);
          this.form.passenger_info[index].invoice_fare=parseInt(invoice)-parseInt(this.form.passenger_info[index].commission);
          var totalBaFare=0;
          this.form.passenger_info.map((passenger,i)=>{
              totalBaFare+=parseInt(passenger.commission);
          });
          this.form.commission=totalBaFare;
          this.calculateFareInformation();
      },
      calculateFareInformation(){
        this.form.gross_fare=parseInt(this.form.base_fare)+parseInt(this.form.total_tax);
        this.form.invoice_fare=(parseInt(this.form.gross_fare)+parseInt(this.form.ait)+parseInt(this.form.markup))-parseInt(this.form.commission);
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                          }
                          this.users = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getCountryList() {
          try {
              axios
                  .get("/api/country/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.status) {
                          let ar=[];
                          let i;
                          let temp=response.data.data;
                          for (i=0;i<temp.length;i++){
                              if(temp[i].phoneCode !== null){
                                  temp[i].value = temp[i].phoneCode;
                                  temp[i].text = temp[i].phoneCode;
                                  ar.push(temp[i]);
                              }
                          }
                          this.country_list=ar;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      // async getBookingDetail() {
      //     try {
      //         axios
      //             .post("/api/flight-booking/details/" + this.bookingId, {
      //                 accessToken: localStorage.getItem("access_tocken"),
      //             })
      //             .then((response) => {
      //                 if (response.data.status) {
      //                     // let passInfo=response.data.data.flight_passengers;
      //                     // let tick=response.data.data.tickets;
      //                     // let j;
      //                     // let assign=new Array();
      //                     // if(tick.length==0){
      //                     //     for(j=0;j<passInfo.length;j++){
      //                     //         assign[j]={ticket_no:''};
      //                     //     }
      //                     //     this.form.tickets=assign;
      //                     // }else{
      //                     //     this.form.tickets=tick;
      //                     // }
      //                     this.form.passenger_info=response.data.data.flight_passengers;
      //                     this.booking=response.data.data;
      //                     let segments=response.data.data.flight_segments;
      //                     let i;
      //                     for (i=0;i<segments.length;i++){
      //                        let arrival=segments[i].arrival_date.split(' ').join('T');
      //                         let departure=segments[i].destination_date.split(' ').join('T');
      //                         segments[i].arrival_date=arrival;
      //                         segments[i].destination_date=departure;
      //                     }
      //                     this.form.flight_segments=segments;
      //                     // this.status=response.data.data.status;
      //                     let book=response.data.data;
      //                     this.form.booking_status=response.data.data.booking_status.status_tag;
      //                     this.form.airline_pnr=book.airline_pnr;
      //                     this.form.api_pnr=book.api_pnr;
      //                     this.form.base_fare=book.base_fare;
      //                     this.form.gross_fare=book.gross_fare;
      //                     this.form.total_tax=book.total_tax;
      //                     this.form.invoice_fare=book.invoice_fare;
      //                     this.form.ait=book.ait;
      //                     this.form.currency=book.currency;
      //                     this.form.airline=book.airline;
      //                     this.form.trip_type=book.trip_type;
      //                     this.form.commission=book.commission;
      //                     this.form.markup=book.markup;
      //                     this.form.payment_status=book.payment_status;
      //
      //                 } else {
      //                     var str = response.data.message;
      //                     var jsonParse = JSON.parse(str);
      //                     this.errorCheck(jsonParse);
      //                 }
      //             })
      //             .catch((error) => {
      //                 console.log(error.message);
      //             });
      //     } catch (err) {
      //         console.log(err);
      //     }
      // },
      async getVendorList() {
          try {
              axios
                  .get("/api/vendor/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.vendors = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async getBookingStatuses() {
          try {
              axios
                  .get("/api/flight-booking/statuses", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.booking_statuses = response.data.data;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/flight-booking/create", {
            user_id: this.form.user_id,
            search_reference_key:this.form.search_reference_key,
            api_vendor: this.form.api_vendor,
            airline_pnr: this.form.airline_pnr,
            api_pnr: this.form.api_pnr,
            base_fare: this.form.base_fare,
            gross_fare: this.form.gross_fare,
            total_tax: this.form.total_tax,
            invoice_fare: this.form.invoice_fare,
            ait: this.form.ait,
            currency: this.form.currency,
            airline: this.form.airline,
            trip_type: this.form.trip_type,
            markup:this.form.markup,
            commission: this.form.commission,
            journey: this.form.journey,
            passenger_info: this.form.passenger_info,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.bookingUpdateForm.reset();
            this.$swal("Flight Booking Created", "success");
              this.$router.push({ name: "flight_booking_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors && lineError" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="bookingUpdateForm" @submit.prevent="formSubmit">
                <h4>Booking Information</h4>
              <div class="row custom-border">
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Select User</label>
                          <model-select :options="users"
                                        v-model="form.user_id"
                                        placeholder="Select User">
                          </model-select>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Search Reference Key</label>
                          <input
                              id="search_reference_key"
                              v-model="form.search_reference_key"
                              name="search_reference_key"
                              type="text"
                              class="form-control"
                              placeholder="search reference key"
                              :class="{ 'is-invalid': submitted && $v.form.search_reference_key.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.search_reference_key.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airline_pnr.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Select Api Vendor</label>
                          <select
                              id="booking_status"
                              name="booking_status"
                              v-model="form.api_vendor"
                              class="form-control"
                              placeholder="Type Status">
                              <option v-for="(vendor, index) in vendors" :value="vendor.id" v-if="vendor.api_name_tag==='manual-1b' ||vendor.api_name_tag==='manual-1g'"
                                      v-bind:key="index">{{ vendor.api_provider }}
                              </option>
                          </select>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Airline</label>
                          <input
                              id="airline"
                              v-model="form.airline"
                              name="airline"
                              type="text"
                              class="form-control"
                              placeholder="airline"
                              :class="{ 'is-invalid': submitted && $v.form.airline.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airline.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airline.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label >Trip Type</label>
                          <select
                              id="trip_type"
                              v-model="form.trip_type"
                              name="trip_type"
                              type="text"
                              class="form-control"
                              placeholder="Type Trip Type"
                              value
                              :class="{ 'is-invalid': submitted && $v.form.trip_type.$error }">
                              <option value="" disabled style="display:none" selected>Select Trip Type</option>
                              <option value="O">One Way</option>
                              <option value="R">Round Trip</option>
                              <option value="M">Multi City</option>
                          </select>
                          <div
                              v-if="submitted && $v.form.trip_type.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.trip_type.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Airline Pnr</label>
                          <input
                              id="airline_pnr"
                              v-model="form.airline_pnr"
                              name="airline_pnr"
                              type="text"
                              class="form-control"
                              placeholder="airline pnr"
                              :class="{ 'is-invalid': submitted && $v.form.airline_pnr.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.airline_pnr.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.airline_pnr.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Api Pnr</label>
                          <input
                              id="api_pnr"
                              v-model="form.api_pnr"
                              name="api_pnr"
                              type="text"
                              class="form-control"
                              placeholder="api pnr"
                              :class="{ 'is-invalid': submitted && $v.form.api_pnr.$error }"
                          />
                          <div
                              v-if="submitted && $v.form.api_pnr.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.api_pnr.required">This value is required.</span>
                          </div>
                      </div>
                  </div>

              </div>

                <h4>Flight Information</h4>
                <div class="row">
                    <div class="col-md-4 custom-border" v-for="(segment,index) in form.journey"  v-bind:key="index" >

                        <div><h5>Journey {{ index + 1}}</h5></div>
<!--                        <h5>Journey {{ segment}}</h5>-->
                        <div class="custom-border" v-for="(flight,i) in segment.flight_segments"  v-bind:key="i">
<!--                            <h5>{{index}}</h5>-->

                            <div><h5>segment {{ i + 1}}</h5></div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Operating Flight Number</label>
                                    <input
                                        id="operating_flight_number+'index'"
                                        v-model="form.journey[index].flight_segments[i].operating_flight_number"
                                        name="operating_flight_number+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="flight number"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].operating_flight_number.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].operating_flight_number.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Airline Code</label>
                                    <input
                                        id="operating_airline_code+'index'"
                                        v-model="form.journey[index].flight_segments[i].operating_airline_code"
                                        name="operating_airline_code+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="airline code"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].operating_flight_number.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].operating_flight_number.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Origin</label>
                                    <input
                                        id="origin_code+'index'"
                                        v-model="form.journey[index].flight_segments[i].origin_code"
                                        name="origin_code+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="origin code"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].origin_code.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].origin_code.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Origin Terminal</label>
                                    <input
                                        id="origin_terminal+'index'"
                                        v-model="form.journey[index].flight_segments[i].origin_terminal"
                                        name="origin_terminal+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="origin terminal"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].origin_code.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].origin_code.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Destination</label>
                                    <input
                                        id="destination_code+'index'"
                                        v-model="form.journey[index].flight_segments[i].destination_code"
                                        name="destination_code+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="destination code"

                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].destination_code.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].destination_code.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Destination Terminal</label>
                                    <input
                                        id="destination_terminal+'index'"
                                        v-model="form.journey[index].flight_segments[i].destination_terminal"
                                        name="destination_terminal+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="destination terminal"

                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].destination_code.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].destination_code.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <b-form-group
                                    id="destination_date+'index'"
                                    label-cols-sm="12"
                                    label-cols-lg="12"
                                    label="Departure Date Time"
                                    label-for="Departure Date Time"
                                >
                                    <!--                                <b-form-datepicker id="destination_date+'index'" v-model="form.flight_segments[index].destination_date" value="form.passenger_info[index].arrival_date"  class="mb-2"></b-form-datepicker>-->
                                    <b-form-input id="destination_date+'index'" v-model="form.journey[index].flight_segments[i].destination_date" :value="form.journey[index].flight_segments[i].destination_date"  type="datetime-local"></b-form-input>

                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.flight_segments[index].destination_date.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.flight_segments[index].destination_date.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group
                                    id="arrival_date+'index'"
                                    label-cols-sm="12"
                                    label-cols-lg="12"
                                    label="Arrival Date Time"
                                    label-for="Arrival Date Time"
                                >
                                    <b-form-input id="arrival_date+'index'" v-model="form.journey[index].flight_segments[i].arrival_date" :value="form.journey[index].flight_segments[i].arrival_date"  type="datetime-local"></b-form-input>
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.flight_segments[index].arrival_date.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.flight_segments[index].arrival_date.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Travel Duration</label>
                                    <input
                                        id="travel_duration+'index'"
                                        v-model="form.journey[index].flight_segments[i].travel_duration"
                                        name="travel_duration+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="travel duration"
                                    />
                                    <!--                                                                <div-->
                                    <!--                                                                    v-if="submitted && $v.form.form.flight_segments[index].travel_duration.$error"-->
                                    <!--                                                                    class="invalid-feedback"-->
                                    <!--                                                                >-->
                                    <!--                                                                    <span v-if="!$v.form.form.flight_segments[index].travel_duration.required">This value is required.</span>-->
                                    <!--                                                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Fare Basis</label>
                                    <input
                                        id="fare_basis+'index'"
                                        v-model="form.journey[index].flight_segments[i].fare_basis"
                                        name="fare_basis+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="fare basis"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].operating_flight_number.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].operating_flight_number.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Booking Class</label>
                                    <input
                                        id="booking_class+'index'"
                                        v-model="form.journey[index].flight_segments[i].booking_class"
                                        name="booking_class+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="booking class"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].booking_class.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].booking_class.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Baggage Info</label>
                                    <input
                                        id="baggage_information+'index'"
                                        v-model="form.journey[index].flight_segments[i].baggage_information"
                                        name="baggage_information+'index'"
                                        type="text"
                                        class="form-control"
                                        placeholder="baggage info"
                                    />
                                    <!--                                <div-->
                                    <!--                                    v-if="submitted && $v.form.form.flight_segments[index].booking_class.$error"-->
                                    <!--                                    class="invalid-feedback"-->
                                    <!--                                >-->
                                    <!--                                    <span v-if="!$v.form.form.flight_segments[index].booking_class.required">This value is required.</span>-->
                                    <!--                                </div>-->
                                </div>
                            </div>
                            <button class="btn btn-outline-primary btn-sm" @click.prevent="addSegment(index)">Add Segment</button>
                            <button class="custom-float-right btn-danger" @click.p.prevent="deleteSegment(index)">X</button>
                        </div>
                        <button class="btn btn-outline-primary btn-sm" @click.prevent="addJourney()">Add Journey</button>
                        <button class="custom-float-right btn-danger" @click.p.prevent="deleteJourney()">X</button>
                    </div>
                </div>


                <div class="spacer"></div>
                <h4>Passenger Information</h4>
                <div class="row">
                    <div class="col-md-4 custom-border" v-for="(passenger,index) in form.passenger_info" v-bind:key="index">

                        <h5>Passenger {{index+1}}</h5>
<!--                        <div class="col-md-12">-->
<!--                            <div class="form-group">-->
<!--                                <label>Prefix</label>-->
<!--                                <input-->
<!--                                    id="prefix+'index'"-->
<!--                                    v-model="form.passenger_info[index].prefix"-->
<!--                                    name="prefix+'index'"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="passenger prefix"-->
<!--                                />-->
<!--&lt;!&ndash;                                <div&ndash;&gt;-->
<!--&lt;!&ndash;                                    v-if="submitted && $v.form.form.passenger_info[index].prefix.$error"&ndash;&gt;-->
<!--&lt;!&ndash;                                    class="invalid-feedback"&ndash;&gt;-->
<!--&lt;!&ndash;                                >&ndash;&gt;-->
<!--&lt;!&ndash;                                    <span v-if="!$v.form.form.passenger_info[index].prefix.required">This value is required.</span>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Prefix</label>
                                <select
                                    id="prefix+'index'"
                                    v-model="form.passenger_info[index].prefix"
                                    name="prefix+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="prefix"
                                >
                                    <option value="" disabled style="display:none" selected>Prefix</option>
                                    <option value="Miss">Miss</option>
                                    <option value="Mr">Mr</option>
                                    <option value="Mrs">Mrs</option>
                                    <option value="Mstr">Mstr</option>
                                    <option value="Ms">Ms</option>
                                </select>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>First Name</label>
                                <input
                                    id="passenger_info+'index'"
                                    v-model="form.passenger_info[index].first_name"
                                    name="passenger_info+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger first name"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].first_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].first_name.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Last Name</label>
                                <input
                                    id="last_name+'index'"
                                    v-model="form.passenger_info[index].last_name"
                                    name="last_name+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger last name"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].last_name.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].last_name.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="birth_date+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Birth Date"
                                label-for="end_dateTime"
                            >
<!--                                <b-form-datepicker id="birth_date+'index'" v-model="form.passenger_info[index].date_of_birth" value="form.passenger_info[index].date_of_birth"  class="mb-2"></b-form-datepicker>-->
                                <b-form-input id="birth_date+'index'" v-model="form.passenger_info[index].date_of_birth" :value="form.passenger_info[index].date_of_birth" type="date"></b-form-input>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].date_of_birth.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].date_of_birth.required">This value is required.</span>-->
<!--                                </div>-->
                            </b-form-group>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passenger Type</label>
                                <select
                                    id="passenger_type+'index'"
                                    v-model="form.passenger_info[index].passenger_type"
                                    name="prefix+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="prefix"
                                >
                                    <option value="" disabled style="display:none" selected>Pax Type</option>
                                    <option value="ADT">ADT</option>
                                    <option value="CHD">CHD</option>
                                    <option value="CNN">CNN</option>
                                    <option value="INF">INF</option>
                                </select>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Is Lead Passenger</label>
                                <select
                                    id="is_lead_pax+'index'"
                                    v-model="form.passenger_info[index].is_lead_pax"
                                    name="trip_type"
                                    type="text"
                                    class="form-control"
                                    placeholder="is lead passenger"
                                   >
                                    <option value="" disabled style="display:none" selected>Is lead pax</option>
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                </select>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].is_lead_pax.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].is_lead_pax.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gender</label>
                                <select
                                    id="gender+'index'"
                                    v-model="form.passenger_info[index].gender"
                                    name="gender+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Type gender"
                                    value
                                   >
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                </select>
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.passenger_info[index].gender.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.passenger_info[index].gender.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Nationality</label>
                                <input
                                    id="nationality+'index'"
                                    v-model="form.passenger_info[index].nationality"
                                    name="nationality+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passenger nationality"

                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].nationality.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].nationality.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Base Fare</label>
                                <input
                                    id="base_fare+'index'"
                                    v-model="form.passenger_info[index].base_fare"
                                    @change="calculateFromBaseFare(index)"
                                    name="base_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="base fare"
                                />

                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Total Tax</label>
                                <input
                                    id="total_tax+'index'"
                                    v-model="form.passenger_info[index].total_tax"
                                    @change="calculateFromTotalTax(index)"
                                    name="total_tax+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="total tax"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Gross Fare</label>
                                <input
                                    id="gross_fare+'index'"
                                    v-model="form.passenger_info[index].gross_fare"
                                    name="gross_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="gross fare"
                                    disabled
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].gross_fare.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].gross_fare.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Ait</label>
                                <input
                                    id="ait+'index'"
                                    v-model="form.passenger_info[index].ait"
                                    @change="calculateFromAit(index)"
                                    name="ait+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="ait"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Markup</label>
                                <input
                                    id="passenger_markup+'index'"
                                    v-model="form.passenger_info[index].markup"
                                    @change="calculateFromMarkup(index)"
                                    name="passenger_markup+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="markup"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Commission</label>
                                <input
                                    id="commission+'index'"
                                    v-model="form.passenger_info[index].commission"
                                    @change="calculateFromCommission(index)"
                                    name="total_tax+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="commission"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Invoice Fare</label>
                                <input
                                    id="invoice_fare+'index'"
                                    v-model="form.passenger_info[index].invoice_fare"
                                    name="invoice_fare+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="invoice fare"
                                    disabled
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].invoice_fare.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].invoice_fare.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Currency</label>
                                <input
                                    id="currency+'index'"
                                    v-model="form.passenger_info[index].currency"
                                    name="currency+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="currency"

                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].total_tax.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].total_tax.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passport No.</label>
                                <input
                                    id="passport_no+'index'"
                                    v-model="form.passenger_info[index].passport_no"
                                    name="passport_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passport number"
                                />
<!--                                <div-->
<!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
<!--                                    class="invalid-feedback"-->
<!--                                >-->
<!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
<!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Passport No.</label>
                                <input
                                    id="passport_issue_country+'index'"
                                    v-model="form.passenger_info[index].passport_issue_country"
                                    name="passport_issue_country+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="passport issue country"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-form-group
                                id="passport_expiry+'index'"
                                label-cols-sm="12"
                                label-cols-lg="12"
                                label="Passport Expiry"
                                label-for="passport_expiry"
                            >
                                <!--                                <b-form-datepicker id="birth_date+'index'" v-model="form.passenger_info[index].date_of_birth" value="form.passenger_info[index].date_of_birth"  class="mb-2"></b-form-datepicker>-->
                                <b-form-input id="passport_expiry+'index'" v-model="form.passenger_info[index].passport_expiry" :value="form.passenger_info[index].passport_expiry" type="date"></b-form-input>
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.passenger_info[index].date_of_birth.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.passenger_info[index].date_of_birth.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </b-form-group>
                        </div>

<!--                        <div class="col-md-12">-->
<!--                            <div class="form-group">-->
<!--                                <label>Phone Code</label>-->
<!--                                <input-->
<!--                                    id="phone_code+'index'"-->
<!--                                    v-model="form.passenger_info[index].phone_code"-->
<!--                                    name="phone_code+'index'"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="phone code"-->
<!--                                />-->
<!--                                &lt;!&ndash;                                <div&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    v-if="submitted && $v.form.form.passenger_info[index].gross_fare.$error"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    class="invalid-feedback"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                >&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    <span v-if="!$v.form.form.passenger_info[index].gross_fare.required">This value is required.</span>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Select Phone Code</label>
                                <model-select :options="country_list"
                                              v-model="form.passenger_info[index].phone_code"
                                              placeholder="Select Phone Code">
                                </model-select>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input
                                    id="phone_number+'index'"
                                    v-model="form.passenger_info[index].phone_number"
                                    name="phone_number+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="phone number"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].gross_fare.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].gross_fare.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Ticket No.</label>
                                <input
                                    id="ticket_no'index'"
                                    v-model="form.passenger_info[index].ticket_no"
                                    name="ticket_no+'index'"
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter Ticket Number"
                                />
                                <!--                                <div-->
                                <!--                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"-->
                                <!--                                    class="invalid-feedback"-->
                                <!--                                >-->
                                <!--                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>-->
                                <!--                                </div>-->
                            </div>
                        </div>
<!--                        <div v-if="form.booking_status==='ticket-confirmed'" class="col-md-12">-->
<!--                            <div class="form-group">-->
<!--                                <label>Ticket No.</label>-->
<!--                                <input-->
<!--                                    id="ticket_no+'index'"-->
<!--                                    v-model="form.tickets[index].ticket_no"-->
<!--                                    name="ticket_no+'index'"-->
<!--                                    type="text"-->
<!--                                    class="form-control"-->
<!--                                    placeholder="ticket number"-->
<!--                                />-->
<!--                                &lt;!&ndash;                                <div&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    v-if="submitted && $v.form.form.passenger_info[index].passport_no.$error"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    class="invalid-feedback"&ndash;&gt;-->
<!--                                &lt;!&ndash;                                >&ndash;&gt;-->
<!--                                &lt;!&ndash;                                    <span v-if="!$v.form.form.passenger_info[index].passport_no.required">This value is required.</span>&ndash;&gt;-->
<!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                            </div>-->
<!--                        </div>-->
                        <button class="btn btn-outline-primary btn-sm" @click.prevent="addPassenger()">Add Passenger</button>
                        <button class="custom-float-right btn-danger" @click.p.prevent="deletePassenger()">X</button>
                    </div>
                </div>
                <h4>Fare Information</h4>
                <div class="row custom-border">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Base Fare</label>
                            <input
                                id="base_fare"
                                v-model="form.base_fare"
                                name="base_fare"
                                type="text"
                                class="form-control"
                                placeholder="base fare"
                                :class="{ 'is-invalid': submitted && $v.form.base_fare.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.base_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.base_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Total Tax</label>
                            <input
                                id="total_tax"
                                v-model="form.total_tax"
                                name="total_tax"
                                type="text"
                                class="form-control"
                                placeholder="total tax"
                                :class="{ 'is-invalid': submitted && $v.form.total_tax.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.total_tax.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.total_tax.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Gross Fare</label>
                            <input
                                id="gross_fare"
                                v-model="form.gross_fare"
                                name="gross_fare"
                                type="text"
                                class="form-control"
                                placeholder="gross fare"
                                :class="{ 'is-invalid': submitted && $v.form.gross_fare.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.gross_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.gross_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>


                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Invoice Fare</label>
                            <input
                                id="invoice_fare"
                                v-model="form.invoice_fare"
                                name="invoice_fare"
                                type="text"
                                class="form-control"
                                placeholder="invoice fare"
                                :class="{ 'is-invalid': submitted && $v.form.invoice_fare.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.invoice_fare.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.invoice_fare.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Ait</label>
                            <input
                                id="ait"
                                v-model="form.ait"
                                name="ait"
                                type="text"
                                class="form-control"
                                placeholder="ait"
                                :class="{ 'is-invalid': submitted && $v.form.ait.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.ait.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.ait.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Markup</label>
                            <input
                                id="markup"
                                v-model="form.markup"
                                name="markup"
                                type="text"
                                class="form-control"
                                placeholder="markup"
                                :class="{ 'is-invalid': submitted && $v.form.markup.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.markup.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.markup.required">This value is required.</span>
                            </div>
                        </div>
                    </div>



                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Commission</label>
                            <input
                                id="commission"
                                v-model="form.commission"
                                name="commission"
                                type="text"
                                class="form-control"
                                placeholder="commission"
                                :class="{ 'is-invalid': submitted && $v.form.commission.$error }"
                                disabled
                            />
                            <div
                                v-if="submitted && $v.form.commission.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.commission.required">This value is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Currency</label>
                            <input
                                id="currency"
                                v-model="form.currency"
                                name="currency"
                                type="text"
                                class="form-control"
                                placeholder="currency"
                                :class="{ 'is-invalid': submitted && $v.form.currency.$error }"
                            />
                            <div
                                v-if="submitted && $v.form.currency.$error"
                                class="invalid-feedback"
                            >
                                <span v-if="!$v.form.currency.required">This value is required.</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="spacer"></div>
              <button class="btn btn-primary" type="submit">Create Flight Booking</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.spacer{
    padding:10px;
}
.custom-border{
    border-style: solid;
    border-width: thin;
    padding-top: 10px;
    padding-bottom:10px;
    margin-bottom:10px;
}
.custom-float-right{
    float:right;
}

</style>
